/* ALTGOLD: troca a foto do card ao escolher uma cor (substitui o Swatch King). ~1 KB, sem dependÃĒncias. */
(() => {
  const activate = (btn) => {
    const card = btn.closest('.card-wrapper');
    if (!card || btn.getAttribute('aria-pressed') === 'true') return;

    const img = card.querySelector('.card__media .media img');
    if (img && btn.dataset.srcset) {
      img.srcset = btn.dataset.srcset;
      img.src = btn.dataset.src;
    }

    card.classList.add('card-wrapper--swatched');
    card.querySelectorAll('a.full-unstyled-link').forEach((a) => (a.href = btn.dataset.url));
    btn.parentElement
      .querySelectorAll('.card-swatch')
      .forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.card-swatch');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    activate(btn);
  });

  if (window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', (e) => {
      const btn = e.target.closest('.card-swatch');
      if (btn) activate(btn);
    });
  }
})();